import { supabase } from '../lib/supabase';

function fromRow(row) {
  const expiresAt = new Date(row.expires_at).getTime();
  const now       = Date.now();

  let status;
  if (row.status === 'simmering') {
    status = expiresAt <= now ? 'ready' : 'waiting';
  } else if (row.status === 'purchased') {
    status = 'bought';
  } else {
    status = row.status; // 'skipped'
  }

  return {
    id:        row.id,
    userId:    row.user_id,
    url:       row.url,
    name:      row.product_name,
    price:     row.price != null ? parseFloat(row.price) : null,
    image:     row.image_url   || null,
    category:  row.category    || null,
    siteName:  row.retailer    || null,
    addedAt:   new Date(row.created_at).getTime(),
    expiresAt,
    decidedAt: row.decided_at ? new Date(row.decided_at).getTime() : null,
    status,
  };
}

function toRow(item) {
  return {
    id:           item.id,
    user_id:      item.userId,
    url:          item.url,
    product_name: item.name,
    price:        item.price,
    image_url:    item.image,
    category:     item.category,
    retailer:     item.siteName,
    created_at:   new Date(item.addedAt).toISOString(),
    expires_at:   new Date(item.expiresAt).toISOString(),
    decided_at:   item.decidedAt ? new Date(item.decidedAt).toISOString() : null,
    status:       item.status === 'bought'                               ? 'purchased'
                : (item.status === 'waiting' || item.status === 'ready') ? 'simmering'
                : item.status,
  };
}

function toUpdateRow(updates) {
  const row = {};
  if (updates.status !== undefined) {
    row.status =
      updates.status === 'bought'                                      ? 'purchased'
      : (updates.status === 'waiting' || updates.status === 'ready')   ? 'simmering'
      : updates.status;
  }
  if (updates.decidedAt !== undefined) {
    row.decided_at = updates.decidedAt ? new Date(updates.decidedAt).toISOString() : null;
  }
  if (updates.expiresAt !== undefined) {
    row.expires_at = new Date(updates.expiresAt).toISOString();
  }
  return row;
}

export async function fetchItems(userId) {
  const { data, error } = await supabase
    .from('items')
    .select('*')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  return { data: data ? data.map(fromRow) : null, error };
}

export async function createItem(item) {
  const { data, error } = await supabase
    .from('items')
    .insert(toRow(item))
    .select()
    .single();
  return { data: data ? fromRow(data) : null, error };
}

export async function updateItem(id, updates) {
  const { data, error } = await supabase
    .from('items')
    .update(toUpdateRow(updates))
    .eq('id', id)
    .select()
    .single();
  return { data: data ? fromRow(data) : null, error };
}

export async function deleteItem(id) {
  return supabase.from('items').delete().eq('id', id);
}
